/**
 * Membership 5787 — contact validation for a non-member requesting High
 * Holiday guest seats. Kept separate from householdValidation.js since a
 * guest fills in only a name + email (enough for the office to follow up),
 * not the full household intake form members complete.
 */
const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const validateGuestContact = ({ name, email } = {}) => {
  const errors = {};

  if (!name || !name.trim()) {
    errors.name = 'Name is required';
  }

  if (!email || !email.trim()) {
    errors.email = 'Email is required';
  } else if (!EMAIL_REGEX.test(email.trim())) {
    errors.email = 'Enter a valid email';
  }

  return { valid: Object.keys(errors).length === 0, errors };
};

// At least one named seat, mirroring kbt-backend's
// membership/guestSeatValidation.js ("At least one seat is required for a
// guest seat purchase").
//
// validateSeatPeople cannot cover this: it only checks that rows which
// EXIST have names, so it returns valid for an empty list. That let a guest
// fill in their contact details, add no seats, and submit — the backend
// rejected it and the page surfaced the raw 422 "Invalid guest seat
// request", the same opaque failure that blocked checkout for ten days.
// Checking here means the browser says something useful instead of
// round-tripping to a certain failure.
export const validateGuestSeatCount = (additionalSeatPeople) => {
  const rows = Array.isArray(additionalSeatPeople) ? additionalSeatPeople : [];
  const named = rows.filter((p) => typeof p?.name === 'string' && p.name.trim().length > 0);

  return named.length > 0
    ? { valid: true, error: null }
    : { valid: false, error: 'Add at least one seat to request guest seats.' };
};
